import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import Loader from "../../Atoms/Loader";

export default function LoginPage() {
  const { keycloak, initialized } = useKeycloak();

  const PROCCESS_HOME_URL = '/projects';
  const BUSINESS_HOME_URL = '/';

  const navigate = useNavigate();

  const handleRedirect = () => {
    const tokenParsed = keycloak.tokenParsed;
    const realmRoles = tokenParsed?.realm_access?.roles || [];

    const isMjvUser = realmRoles.includes('mjv-user');
    const isUser = realmRoles.includes('user');

    if (isMjvUser && isUser) {
      const email = (tokenParsed?.email || '').toLowerCase();
      return email.includes('@mjv') ? PROCCESS_HOME_URL : BUSINESS_HOME_URL;
    }

    return isMjvUser ? PROCCESS_HOME_URL : BUSINESS_HOME_URL;
  };

  useEffect(() => {
    if (initialized) {
      if (!keycloak.authenticated) {
        keycloak.login();
      } else {
        navigate(handleRedirect());
      }
    }
  }, [initialized, keycloak, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <Loader />
    </div>
  );
}